<template>
  <div class="content">
      <iframe :src="srcs" class="iframe-sty" :style="height"></iframe>
  </div>
</template>

<script> 
import { bpmnroute } from '../../api/apiRoute';
export default {
  data() {
    return { 
     srcs: '',
     winHeight: window.innerHeight,
      height: {
        height: '',
      },
      roleGuids:[],  
    };
  },
  created() {  
    let self = this;
    // self.getToken();
    this.setSrcs();
  },    
  destroyed(){
    // window.removeEventListener('popstate',false);//false阻止默认事件
  },
  mounted(){    
    // this.getCommit(); 
    window.onresize = () => { 
    return (() => { 
    this.winHeight = window.innerHeight 
        })
    } 
    this.height.height=this.winHeight-89+'px'; 
  }, 
  methods: {
    setSrcs() { 
      this.srcs = bpmnroute + '/bpmn?token='+ localStorage.token + '&flowTemplateGuid='+ this.$route.query.flowTemplateGuid + '&deploymentId='+ this.$route.query.deploymentId + '&tenantGuid='+ this.$route.query.tenantGuid + '&flowName='+ this.$route.query.flowName+ '&display=false';
    },
    getToken(){
      let self = this; 
      self.api.postJson(`/csbr-zuul/user/refreshToken?token=${localStorage.token}`).then(res => {
        if (res.data.msg == "token延期成功!") {
          let token = res.data.data.refreshToken;
          self.srcs = bpmnroute + '/bpmn?token='+ token + '&flowTemplateGuid='+ self.$route.query.flowTemplateGuid + '&deploymentId='+ self.$route.query.deploymentId + '&tenantGuid='+ self.$route.query.tenantGuid + '&flowName='+ self.$route.query.flowName+ '&display=false';
          console.log('9999',self.srcs,bpmnroute)
        }
      })
    },
     
  },
};
</script>
<style  scoped>
 .content {
  margin: 0px;
 }
 .iframe-sty{ 
  width:100%;
  border:none; 
 }
</style>